(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var modal = document.querySelector("[data-notify-me-modal]");
    if (modal) setupNotifyMeModal(modal);
  });

  function setupNotifyMeModal(modal) {
    var form = modal.querySelector("[data-notify-me-form]");
    var headline = modal.querySelector("[data-notify-me-headline]");
    var body = modal.querySelector("[data-notify-me-body]");
    var message = modal.querySelector("[data-notify-me-message]");
    var submitBtn = modal.querySelector("[data-notify-me-submit]");
    var klaviyoAccount = modal.dataset.klaviyoAccount;
    var klaviyoListId = modal.dataset.klaviyoListId;
    var klaviyoApiRevision = "2025-07-15";
    var currentVariantId = null;

    function open(trigger) {
      currentVariantId = trigger.dataset.notifyVariantId;
      if (headline) headline.textContent = trigger.dataset.notifyProductTitle || "";
      if (body) body.hidden = false;
      form.hidden = false;
      form.reset();
      message.hidden = true;
      modal.hidden = false;
    }

    function close() {
      modal.hidden = true;
    }

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-notify-me-trigger]");
      if (trigger) {
        e.preventDefault();
        if (trigger.disabled) return;
        open(trigger);
        return;
      }
      if (e.target.closest("[data-notify-me-close]")) {
        close();
      }
    });

    document.addEventListener("product:variant-change", function (e) {
      var variant = e.detail.variant;
      document.querySelectorAll("[data-notify-me-toggle]").forEach(function (trigger) {
        if (variant && !variant.available) {
          trigger.hidden = false;
          trigger.dataset.notifyVariantId = variant.id;
        } else {
          trigger.hidden = true;
        }
      });
    });

    if (!form) return;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!currentVariantId || !klaviyoAccount) return;

      var email = form.email.value;
      var subscribeChecked = !!(form.subscribe && form.subscribe.checked);

      submitBtn.disabled = true;

      var requests = [
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=" + klaviyoAccount, {
          method: "POST",
          headers: { "Content-Type": "application/vnd.api+json", revision: klaviyoApiRevision },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: { data: { type: "profile", attributes: { email: email } } }
              },
              relationships: {
                variant: {
                  data: { type: "catalog-variant", id: "$shopify:::$default:::" + currentVariantId }
                }
              }
            }
          })
        })
      ];

      if (subscribeChecked && klaviyoListId) {
        requests.push(
          fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + klaviyoAccount, {
            method: "POST",
            headers: { "Content-Type": "application/vnd.api+json", revision: klaviyoApiRevision },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: email,
                        subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
                      }
                    }
                  }
                },
                relationships: { list: { data: { type: "list", id: klaviyoListId } } }
              }
            })
          })
        );
      }

      Promise.all(requests)
        .then(function (responses) {
          submitBtn.disabled = false;
          var ok = responses.every(function (r) {
            return r.ok;
          });
          if (body) body.hidden = ok;
          form.hidden = ok;
          message.hidden = false;
          message.dataset.state = ok ? "success" : "error";
          message.textContent = ok ? message.dataset.successLabel : message.dataset.errorLabel;
        })
        .catch(function () {
          submitBtn.disabled = false;
          message.hidden = false;
          message.dataset.state = "error";
          message.textContent = message.dataset.errorLabel;
        });
    });
  }
})();
